export default __webpack_public_path__ + "97fe4fc40681aefffd8f6cd693433f52.svg";